// Per-field placement preferences (client-side, per browser)
export const PLACEMENT_KEY = "fleet_field_placement";
export const ORDER_KEY = "fleet_col_order";

// Fields shown in BOTH table and detail by default; everything else -> detail only
export const DEFAULT_BOTH = [
  "agent", "asset_tag", "device_code", "location_id", "location_name", "group", "teamviewer_id", "payload_version", "last_seen", "actions",
  "extra.avb", "extra.scanner_serial", "extra.scanner_connected", "extra.Ort", "extra.Agentur", "extra.Erreicht ?",
];

export const BASE_FIELDS = [
  "device_code", "location_id", "location_name", "group", "hostname", "device_uid",
  "teamviewer_id", "tablet_serial", "manufacturer", "model", "os_version",
  "agent_version", "payload_version", "first_seen", "last_seen",
];

export function loadPlacement() {
  try { return JSON.parse(localStorage.getItem(PLACEMENT_KEY)) || {}; } catch { return {}; }
}
export function savePlacement(map) {
  localStorage.setItem(PLACEMENT_KEY, JSON.stringify(map));
}
export function loadOrder() {
  try { return JSON.parse(localStorage.getItem(ORDER_KEY)) || []; } catch { return []; }
}
export function saveOrder(arr) {
  localStorage.setItem(ORDER_KEY, JSON.stringify(arr));
}

export function placementOf(map, key) {
  if (map && map[key]) return map[key];           // table | detail | both | off
  return DEFAULT_BOTH.includes(key) ? "both" : "detail";
}
export function inTable(map, key) {
  const p = placementOf(map, key);
  return p === "table" || p === "both";
}
export function inDetail(map, key) {
  const p = placementOf(map, key);
  return p === "detail" || p === "both";
}

export function applyOrder(keys, order) {
  const seen = new Set();
  const out = [];
  for (const k of order) if (keys.includes(k) && !seen.has(k)) { out.push(k); seen.add(k); }
  for (const k of keys) if (!seen.has(k)) out.push(k);
  return out;
}

export const LABELS = {
  "group": "Gruppe",
  "payload_version": "Skript-Version",
  "extra.Agentur": "Betriebsart",
  "extra.tsrid_app_version": "TSRID-APP",
  "extra.teamviewer_version": "TeamViewer-Version",
  "extra.sdk_version": "SDK",
  "extra.db_dat": "db.dat",
  "extra.devices_dat": "devices.dat",
  "extra.cpu": "CPU",
  "extra.ram": "RAM",
  "extra.disk_size": "Festplatte",
  "extra.disk_free": "Freier Speicher",
  "extra.avb": "AVB",
  "extra.avb": "AVB",
  "extra.AVB´s": "AVB",
  "extra.ip_address": "IP-Adresse",
  "extra.internet": "Internet",
  "extra.mac_address": "MAC-Adresse",
  "extra.scanner_serial": "Scanner-Seriennr.",
  "extra.scanner_type": "Scanner-Typ",
  "extra.scanner_connected": "Scanner verbunden",
};

export function fieldLabel(key, t) {
  if (LABELS[key]) return LABELS[key];
  return key.startsWith("extra.") ? key.slice(6) : t(key);
}
export function fieldValueText(d, key) {
  if (key.startsWith("extra.")) return (d.extra || {})[key.slice(6)] ?? "";
  return d[key] ?? "";
}

// TeamViewer status: online (API grün), offline (API rot), unknown (TV-ID vorhanden, aber kein Live-Status), none (keine TV-ID)
export function tvStatusOf(d) {
  const id = (d.teamviewer_id || "").toString().trim();
  if (!id) return "none";
  if (d.tv_in_account === false) return "attention"; // TV-ID nicht im Konto -> manueller Eingriff nötig
  if (d.tv_online === true) return "online";
  if (d.tv_online === false) return "offline";
  return "unknown";
}
